export const WHITE_LIST_API = 'https://wl-api.mf.gov.pl/api';
